import { PageHeader } from "@/components/app/PageHeader/PageHeader";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { NotificationPreferences } from "./components/NotificationPreferences";
import { EmailPreferences } from "./components/EmailPreferences";

const NotificationsPage: React.FC = () => {
	return (
		<div className="container max-w-screen-lg py-6">
			<PageHeader title="通知設定" description="通知の受信設定を管理できます" />
			<div className="mt-6 space-y-6">
				<Card>
					<CardHeader>アプリ内通知</CardHeader>
					<CardContent>
						<NotificationPreferences />
					</CardContent>
				</Card>
				<Card>
					<CardHeader>メール通知</CardHeader>
					<CardContent>
						<EmailPreferences />
					</CardContent>
				</Card>
			</div>
		</div>
	);
};

export default NotificationsPage;
